/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function GatewayGroupTableConfig($rootScope, $q, $translate, $mdDialog, $document, $state, toast, types, utils, tkDialogs, userService,
                                           gatewayGroupService, customerService, gatewayService, configurationService, firmwareService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        if (params.customerId) {
            scope = types.scope.customer;
        }

        if (params.customerId) {
            customerService.getCustomer(params.customerId).then(
                (customer) => {
                    var tableConfiguration = createGatewayGroupConfig(scope, access, params, customer.title);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            var tableConfiguration = createGatewayGroupConfig(scope, access, params);
            deferred.resolve(tableConfiguration);
        }
        return deferred.promise;
    }

    function createGatewayGroupConfig(scope, access, params, entityTitle) {

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var customerId;

        if (params.customerId) {
            customerId = params.customerId;
        } else {
            customerId = currentUser.customerId;
        }

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.gateway_group,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                {
                    key: 'createdTime',
                    title: 'entity.createdTime'
                },
                {
                    key: 'name',
                    title: 'gateway-group.name'
                },
                {
                    key: 'gatewaysCount',
                    title: 'gateway-group.gateways-count'
                }
            ],

            addEntityController: 'AddGatewayGroupController',

            loadEntities: () => {
                return scope == types.scope.provider
                    ? gatewayGroupService.getProviderGatewayGroups()
                    : gatewayGroupService.getCustomerGatewayGroups(customerId)
            },
            loadEntity: (entityId) => {
                return gatewayGroupService.getGatewayGroup(entityId)
            },
            saveEntity: (entity) => {
                return gatewayGroupService.saveGatewayGroup(entity)
            },
            deleteEntity: (entityId) => {
                return gatewayGroupService.deleteGatewayGroup(entityId)
            },

            addEnabled: () => {
                return access == types.access.admin;
            },

            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('gateway-group.delete-gateway-group-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('gateway-group.delete-gateway-group-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('gateway-group.delete-gateway-groups-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('gateway-group.delete-gateway-groups-text');
            }

        };

        if (!params.customerId && scope == types.scope.provider) {
            tableConfiguration.columns.push(
                {
                    key: 'customerTitle',
                    title: 'gateway-group.assigned-customer'
                }
            );
        }

        tableConfiguration.manageGateways = (event, entity) => {
            manageGateways(event, params.customerId, entity);
        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'gateway-group.assign-to-customer',
                icon: 'assignment_ind',
                isEnabled: (entity) => {
                    return entity && (authority === types.authority.PROVIDER_ADMIN.value && !params.customerId && !entity.customerId);
                },
                onAction: ($event, entity) => {
                    assignToCustomer($event, entity, tableConfiguration);
                }
            },
            {
                name: 'gateway-group.unassign-from-customer',
                icon: 'assignment_return',
                isEnabled: (entity) => {
                    return entity && (authority === types.authority.PROVIDER_ADMIN.value && (params.customerId || entity.customerId));
                },
                onAction: ($event, entity) => {
                    unassignFromCustomer($event, entity, tableConfiguration);
                }
            },
            {
                name: 'gateway-group.manage-gateways',
                icon: 'router',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageGateways($event, params.customerId, entity);
                }
            }
        ];

        tableConfiguration.groupActionMenuDescriptors = [
            {
                name: 'configuration-table.configuration',
                icon: 'settings',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                items: [
                    {
                        name: 'configuration-table.get-configuration-status',
                        icon: 'subject',
                        onAction: ($event, entities) => {
                            getConfigurationStatusOfGateweys($event, entities); 
                        }
                    },
                    {
                        name: 'configuration-table.apply-configuration',
                        icon: 'sync',
                        onAction: ($event, entities) => {
                            applyConfigurationToGatewayGroup($event, entities);
                        }
                    },
                    {
                        name: 'configuration-table.delete-configuration',
                        icon: 'delete',
                        onAction: ($event, entities) => {
                            deleteConfiguration($event, entities);
                        }
                    }
                ]
            },
            {
                name: 'firmware.upgrade',
                icon: 'update',
                isEnabled: () => {
                    return access == types.access.admin;
                },
                items: [
                    {
                        name: 'firmware-table.get-upgrade-status',
                        icon: 'subject',
                        onAction: ($event, entities) => {
                            getFirmwareStatusOfGateweys($event, entities); 
                        }
                    }, 
                    {
                        name: 'firmware.apply-upgrade',
                        icon: 'sync',
                        onAction: ($event, entities) => {
                            applyUpgradeToGatewayGroup($event, entities);
                        }
                    },
                    {
                        name: 'firmware.delete-upgrade',
                        icon: 'delete',
                        onAction: ($event, entities) => {
                            deleteUpgrade($event, entities);
                        }
                    }
                ]
            }
        ]

        tableConfiguration.groupActionDescriptors = [
            {
                name: 'gateway-group.assign-to-customer',
                icon: 'assignment_ind',
                isEnabled: () => {
                    return (authority === types.authority.PROVIDER_ADMIN.value && !params.customerId);
                },
                onAction: ($event, entities) => {
                    assignGatewayGroupsToCustomer($event, entities, tableConfiguration);
                }
            },
            {
                name: 'gateway-group.unassign-from-customer',
                icon: 'assignment_return',
                isEnabled: () => {
                    return (authority === types.authority.PROVIDER_ADMIN.value);
                },
                onAction: ($event, entities) => {
                    unassignGetwayGroupsFromCustomer($event, entities, tableConfiguration);
                }
            },
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('gateway-group.gateway-groups');
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function manageGateways($event, customerId, gatewayGroup) {
        if ($event) {
            $event.stopPropagation();
        }
        if (customerId) {
            $state.go('home.customers.gatewayGroups.gateways', {customerId: customerId, gatewayGroupId: gatewayGroup.id.id});
        } else {
            $state.go('home.gatewayGroups.gateways', {gatewayGroupId: gatewayGroup.id.id});
        }
    }

    function applyConfigurationToGatewayGroup($event, gatewayGroups) {
        tkDialogs.applyConfiguration($event, gatewayGroups, types.entityType.gateway_group);
    }

    function applyUpgradeToGatewayGroup($event, gatewayGroups) {
        tkDialogs.applyUpgrade($event, gatewayGroups, types.entityType.gateway_group);
    }

    function getConfigurationStatusOfGateweys($event, gatewayGroups) {
        var tasks = [];
        var gateways = [];
        $rootScope.loading = true;
        gatewayGroups.forEach((gatewayGroup) => {
            tasks.push(gatewayService.getAllGatewayGroupGateways(gatewayGroup.id.id, {ignoreLoading: true}).then(
                (gws) => {
                    let gws_with_group = gws.map(gw => {return {...gw, gatewayGroupName: gatewayGroup.name}});
                    gateways = [...gateways, ...gws_with_group]
                }
            ))
        });
        $q.all(tasks).then(
            () => { 
                $rootScope.loading = false;
                tkDialogs.showConfigStatus($event, gateways, true) }
        );
    }

    function getFirmwareStatusOfGateweys($event, gatewayGroups) {
        var tasks = [];
        var gateways = [];
        $rootScope.loading = true;
        gatewayGroups.forEach((gatewayGroup) => {
            tasks.push(gatewayService.getAllGatewayGroupGateways(gatewayGroup.id.id, {ignoreLoading: true}).then(
                (gws) => {
                    let gws_with_group = gws.map(gw => {return {...gw, gatewayGroupName: gatewayGroup.name}});
                    gateways = [...gateways, ...gws_with_group]
                }
            ))
        });
        $q.all(tasks).then(
            () => { 
                $rootScope.loading = false;
                tkDialogs.showFirmwareStatus($event, gateways, types.entityType.gateway, true)
            }
        );
    }

    function assignToCustomer($event, gatewayGroup, tableConfiguration) {
        var onEntitySelected = (targetCustomerId) => {
            return gatewayGroupService.assignGatewayGroupToCustomer(targetCustomerId.id, gatewayGroup.id.id);
        };
        tkDialogs.selectEntity($event, types.entityType.customer,
            'gateway-group.assign-gateway-group', 'action.assign',
            'gateway-group.select-target-assign-customer-text',
            'customer.customer-not-found-text',
            'customer.target-customer-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function assignGatewayGroupsToCustomer($event, gatewayGroups, tableConfiguration) {
        var onEntitySelected = (targetCustomerId) => {
            var tasks = [];
            gatewayGroups.forEach((gatewayGroup) => {
                if (!gatewayGroup.customerId) {
                    tasks.push(gatewayGroupService.assignGatewayGroupToCustomer(targetCustomerId.id, gatewayGroup.id.id));
                }
            });
            return $q.all(tasks);
        };
        tkDialogs.selectEntity($event, types.entityType.customer,
            'gateway-group.assign-gateway-groups', 'action.assign',
            'gateway-group.select-target-assign-customer-gateway-groups-text',
            'customer.customer-not-found-text',
            'customer.target-customer-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function unassignFromCustomer($event, gatewayGroup, tableConfiguration) {
        var title = $translate.instant('gateway-group.unassign-gateway-group-title', {gatewayGroupName: gatewayGroup.name});
        var content = $translate.instant('gateway-group.unassign-gateway-group-text');
        var label = $translate.instant('gateway-group.unassign-gateway-group');

        tkDialogs.confirm($event, title, content, label).then(
            () => {
                gatewayGroupService.unassignGatewayGroupFromCustomer(gatewayGroup.id.id).then(
                    () => { tableConfiguration.reloadEntities(true); }
                );
            }
        );
    }

    function unassignGetwayGroupsFromCustomer($event, gatewayGroups, tableConfiguration) {
        var title = $translate.instant('gateway-group.unassign-gateway-groups-title', {count: gatewayGroups.length}, 'messageformat');
        var content = $translate.instant('gateway-group.unassign-gateway-groups-text');
        var label = $translate.instant('gateway-group.unassign-gateway-groups');

        tkDialogs.confirm($event, title, content, label).then(
            () => {
                var tasks = [];
                gatewayGroups.forEach((gatewayGroup) => {
                    if (gatewayGroup.customerId) {
                        tasks.push(gatewayGroupService.unassignGatewayGroupFromCustomer(gatewayGroup.id.id));
                    }
                });
                $q.all(tasks).then(
                    () => { tableConfiguration.reloadEntities(true); }
                );
            }
        );
    }

    function deleteConfiguration($event, gateways) {
        var title = $translate.instant('gateway-group.delete-configuration-title', {count: gateways.length}, 'messageformat');
        var content = $translate.instant('gateway-group.delete-configuration-text');
        var label = $translate.instant('configuration-table.delete-configuration');
        tkDialogs.confirm($event, title, content, label).then(
            () => {
                var tasks = [];
                gateways.forEach((gateway) => {
                    tasks.push(configurationService.deleteJsonConfiguration(types.entityType.gateway_group, gateway.id.id));
                });
                $q.all(tasks).then(
                    () => {
                        toast.showSuccess($translate.instant('gateway-group.delete-configuration-success'), 750, null, 'bottom right');
                    }, ()=>{}
                );
            }
        );
    }
    
    function deleteUpgrade($event, gateways) {
        var title = $translate.instant('gateway-group.delete-upgrade-title', {count: gateways.length}, 'messageformat');
        var content = $translate.instant('gateway-group.delete-upgrade-text');
        var label = $translate.instant('firmware.delete-upgrade');
        tkDialogs.confirm($event, title, content, label).then(
            () => {
                var tasks = [];
                gateways.forEach((gateway) => {
                    tasks.push(firmwareService.deleteFirmwareDesired(types.entityType.gateway_group, gateway.id.id));
                });
                $q.all(tasks).then(
                    () => {
                        toast.showSuccess($translate.instant('gateway-group.delete-upgrade-success'), 750, null, 'bottom right');
                    }, ()=>{}
                );
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway-group/gateway-group-table.config.js